export const pageTitle = (title) => {
  return ( document.title = title + " - Street Stylin Mobile Car Detailing");
}
export {initialState, reducer} from './reducer'